// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"600":"strategy","913":"default"}[chunkId] || chunkId) + "." + {"14":"de8d9942","225":"c84949f1","321":"17c50d85","533":"7d74656a","600":"90ea5051","648":"70ea7a29","726":"fb3895f5","913":"4562c048","959":"feea60f5"}[chunkId] + ".js";
};